module.exports = __webpack_public_path__ + "img/contactding.674b46f9.jpg";